import { h } from '../pragma.mjs';

export default () => {

    return (
        <div>
            <div>
                <gov-breadcrumbs wcag-label="Úroveň zanoření v rozcestníku">
                    <ul class="breadcrumbs">
                        <li><gov-icon type="basic" name="chevron-right"></gov-icon><a id="rozcestnikRoot" href="#">Domů</a></li>
                        <li><gov-icon type="basic" name="chevron-right"></gov-icon><a id="rozcestnikZapisy" href="#">Zápisy</a></li>
                        <li><gov-icon type="basic" name="chevron-right"></gov-icon><strong>Změna údajů o stavbách</strong></li>
                    </ul>
                </gov-breadcrumbs>
            </div>
            
            <gov-tiles role="list">
                <gov-tile role="listitem" id="rozcestnikPostavil2Tile" href="#">
                    <p>Stavba je postavena na pozemku, který je v mém vlastnictví</p>
                    <h3 slot="title">Stavba na vlastním pozemku</h3>
                    <gov-icon type="complex" name="house" slot="icon"></gov-icon>
                </gov-tile>
                <gov-tile role="listitem" id="rozcestnikPostavil3Tile" href="#">
                    <p>Stavba je postavena na pozemku, který není v mém vlastnictví</p>
                    <h3 slot="title">Stavba na cizím pozemku</h3>
                    <gov-icon type="complex" name="property" slot="icon"></gov-icon>
                </gov-tile>
                <gov-tile role="listitem" id="rozcestnikPostavilS8414" href="#">
                    <p>Stavba byla postavena v rámci práva stavby</p>
                    <h3 slot="title">Stavba v právu stavby</h3>
                    <gov-icon type="complex" name="population-register" slot="icon"></gov-icon>
                </gov-tile>
            </gov-tiles>
        </div>
    )

}